import React, {useEffect, useState} from "react";
import {GuildRankingItems} from "./RankingItems";
import "./RankBody.css";
import {_BASE_URL} from "../../const/ConstBase";

export const GuildRankBody = () => {

    const [list, setList] = useState<GuildRankingItems[]>();
    const fetchData = async() => {
        try {
            setList([]);
            const response = await fetch(`${_BASE_URL}rank/guild/daily`, { method : "POST" });
            const data = await response.json();
            if(data && data.data) {
                setList(data.data);
            }
        } catch(error) {

        }
    }

    useEffect(() => {
        fetchData();
        window.scrollTo(0, 0);
    }, []);
    //움브리아, 마그나스, 사라토프, 비블로스, 칼리아리
    return (
        <div className="sub_content_rank">
            <table className="table table-hover">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Nation</th>
                    <th scope="col">Level</th>
                    <th scope="col">Kill Point</th>
                    <th scope="col">Guild</th>
                    <th scope="col">Change</th>
                </tr>
                </thead>
                <tbody>
                { list && list.length > 0 && list.map((item, index) => {
                    return(
                        <tr key={index}>
                            <td className="r_cen">{item.rank}</td>
                            <td className="r_cen">{item.nation}</td>
                            <td className="r_cen">{item.level}</td>
                            <td className="r_cen">{item.kill_point}</td>
                            <td>{item.guild}</td>
                            <td className="r_cen">{item.change_rank}</td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    )
}